import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Input from "../../../../../../components/textbox/Input";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../../utils/Utils";

class SezioneTredici extends Component {

    state = {
        sezioneTredici: {note: "", corretto: []},


    }


    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneTredici) {
            let sezioneTredici = this.state.sezioneTredici
            let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneTredici))
            sezioneTredici.note = propsSezione.note ? propsSezione.note : ""
            this.setState({sezioneTredici: sezioneTredici})
        }
        this.props.setSezioneTredici(this.state.sezioneTredici)

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //this.controllaDati();
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneTredici(this.state.sezioneTredici, res)
        }
    }

    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneTredici))
        let sezioneBackend = Utils.removeEmptyValueFromObject(dati)
        return Utils.removeFieldFromObject(sezioneBackend, "corretto")
    }


    riceviValoreInput(field, event) {

        let sezioneTredici = this.state.sezioneTredici
        if (field.currentTarget) {
            sezioneTredici[field.currentTarget.id] = field.currentTarget.value
        } else {
            sezioneTredici[field] = event.target.value
        }
        this.setState({sezioneTredici: sezioneTredici})
    }

    render() {

        const {t} = this.props;

        const sezioneTredici = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 13</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className={"col-lg-6"}>
                            <p className={styles.testo}>{t("SchedaEpatite.sezione13.note")}</p>
                            <Input
                                type={"textarea"}
                                id="note"
                                field={"note"}
                                onChange={this.riceviValoreInput}
                                value={this.state.sezioneTredici.note}
                                placeholder={"Note"}
                            />
                        </div>
                    </div>
                </div>

            </div>
        );


        return <div>

            {sezioneTredici}
        </div>
    }


}

export default withTranslation('common')(SezioneTredici)
